import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import HelpCard from "../HelpCard";

const Help = () => {
  return (
    <Box
      py={[8, 12]}
      px={[4, 6, 8]}
      bgGradient="linear(to-br, green.50, white)"
    >
      <Box maxW="1400px" mx="auto">
        <Heading
          fontSize={["1.6rem", "2rem"]}
          color="green.700"
          mb={1}
          borderLeft="4px solid"
          borderColor="green.400"
          pl={4}
        >
          Como Ajudar?
        </Heading>
        <Text color="gray.500" pl={4} mb={8} fontSize="1rem">
          Existem várias formas de contribuir com a missão da ACAOL
        </Text>

        <Flex flexDir={["column", "column", "row"]} gap={6}>
          <HelpCard
            title="Patrocínio"
            text="Junte sua marca a este que, em sua modalidade, é o maior evento maçônico do país, com público participante de todos os Estados da Federação. Se seu produto pretende atingir faixas etárias > de 40 anos, num perfil socioeconômico 'C', 'B' e 'A', composto de profissionais liberais, empresários e funcionários de nível acima de supervisão, de nível superior e atuantes em suas comunidades, a Jornada Maçônica do Brasil é o evento adequado para seu planejamento de Marketing. Entre em contato conosco, para conhecer os planos de patrocínio e vincule seu produto/serviços, de forma perene, à XXIX Edição da Jornada Maçônica do Brasil."
            image={`${process.env.PUBLIC_URL}/patroc.png`}
          />
          <HelpCard
            title="Trabalhe Junto"
            text="Se você desejar atuar na Comissão Organizadora da Jornada ou como representante da Jornada Maçônica do Brasil em seu município, entre em contato conosco."
            image={`${process.env.PUBLIC_URL}/trabjunt.png`}
          />
          <HelpCard
            title="Contribuições"
            text="Além do trabalho da Comissão Organizadora, cujos integrantes investem parte de seu tempo para a realização do Evento, a ACAOL, mantenedora do Evento, não se constituindo numa sociedade com fins lucrativos, para entregar uma Jornada Maçônica do Brasil com qualidade, são necessários investimentos, que buscamos captar com Patrocinadores e Apoiadores. No entanto, você, meu Irmão, que já participou ou participará da próxima Jornada Maçônica e identificar nela algo que lhe proporcione valor intrínseco, como acesso à informações de qualidade, se desejar contribuir com qualquer valor, esse ato será muito bem vindo para que nosso projeto venha a apresentar resultados cada vez melhores para os Irmãos. Segue nossa chave de PIX - CNPJ 02542928000123"
            image={`${process.env.PUBLIC_URL}/donate.png`}
          />
        </Flex>
      </Box>
    </Box>
  );
};
export default Help;
